<template>
    <div class="swiper-container" ref="container">
        <header>
            <h2>{{ name }}</h2>
            <div class="spacer"></div>
            <div class="navigation">
                <div class="swiper-button swiper-button-prev" @click="previous">
                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="7" viewBox="0 0 5 7"><path d="M3.5,0,7,5H0Z" transform="translate(5) rotate(90)" fill="#4d4d4d"/></svg>
                </div>
                <div class="swiper-button swiper-button-next" @click="next">
                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="7" viewBox="0 0 5 7"><path d="M3.5,0,7,5H0Z" transform="translate(5) rotate(90)" fill="#4d4d4d"/></svg>
                </div>
            </div>
        </header>
        <div class="swiper-wrapper">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper';

    export default {

        props: {
            name: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                swiper: null,
            };
        },

        mounted() {
            this.swiper = new Swiper(this.$refs.container, {
                spaceBetween: 40,
                slidesPerView: 'auto'
            });
        },

        methods: {
            next() {
                this.swiper.slideNext();
            },

            previous() {
                this.swiper.slidePrev();
            }
        }
    }
</script>